<template>
  <div id="app">
    <div class="eyeBox">
      <div class="eye"></div>
    </div>
    <div id="nav">
      <router-link to="/">Word</router-link>|
      <router-link to="/about">SearchWord</router-link>
    </div>
    <router-view />
    <div id="lanren" @click="top">Top</div>
  </div>
</template>
<script>
export default {
  name: "app",
  data: function() {
    return {};
  },
  created() {
    //   this.$http
    //     .jsonp("https://sp0.baidu.com/5a1Fazu8AA54nxGko9WTAnF6hhy/su", {
    //       params: {
    //         wd: "hello"
    //       },
    //       jsonp: "cb"
    //     })
    //     .then(Response => {
    //       window.console.log(Response);
    //     })
    //     .catch(error => {
    //       window.console.log(error);
    //     });
  },
  methods: {
    top() {
      let distance = document.documentElement.scrollTop,
        speed = 10,
        speed1 = 20,
        speed2 = 30,
        speed3 = 50,
        mo = setInterval(function() {
          window.console.log(distance);
          if (document.documentElement.scrollTop <= 0) {
            clearInterval(mo);
          }
          document.documentElement.scrollTop =
            document.documentElement.scrollTop - 100;
        }, speed);
    }
  }
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  outline: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
  font-size: 16px;
}

#nav {
  padding: 0 20px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.pd20 {
  padding: 0 20px;
}
#lanren {
  position: fixed;
  z-index: 100;
  bottom: 30px;
  right: 8px;
  border: 1px solid black ;
  border-radius: 5px;
  padding: 2px 10px;
  // width: 156px;
  // height: 156px;
  // background: url("https://gitee.com/lambertlt/learn-english/raw/master/foxtail.png")
  //   no-repeat 0 0;
  // animation: animate-tail 2s steps(44) infinite;
}
@keyframes animate-tail {
  0% {
    background-position: -6864px 0;
  }
  100% {
    background-position: 0 0;
  }
}
.eyeBox {
  position: sticky;
  top: 0px;
  z-index: 1000;
  width: 50px;
  height: 30px;
  border-radius: 60%;
  margin: 0 auto;
  padding-right: 28px;
  background-color: rgb(250, 183, 144);
  display: flex;
  justify-content: center;
  align-items: center;
  .eye {
    width: 20px;
    height: 20px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    box-shadow: 30px 0px 0px 0px rgba(255, 255, 255, 0.8);
    position: relative;
    // margin: 36px 26px;
  }

  .eye:after {
    background-color: #59488b;
    width: 10px;
    height: 10px;
    box-shadow: 30px 0px 0px 0px #59488b;
    border-radius: 50%;
    left: 9px;
    top: 8px;
    position: absolute;
    content: "";
    -webkit-animation: eyeball 2s linear infinite alternate;
    -moz-animation: eyeball 2s linear infinite alternate;
    animation: eyeball 2s linear infinite alternate;
  }
  @-webkit-keyframes eyeball {
    0% {
      left: 9px;
    }
    100% {
      left: 1px;
    }
  }
  @-moz-keyframes eyeball {
    0% {
      left: 9px;
    }
    100% {
      left: 1px;
    }
  }
  @keyframes eyeball {
    0% {
      left: 9px;
    }
    100% {
      left: 1px;
    }
  }
}
</style>
